import * as THREE from 'three'
import { CuboidCollider, RigidBody } from '@react-three/rapier'
import { use, useMemo, useRef, useState } from 'react'
import { useFrame } from '@react-three/fiber'
import { Float, useGLTF, Text } from '@react-three/drei'
THREE.ColorManagement.legacyMode = false

const boxGeometry = new THREE.BoxGeometry(1,1,1)
const floorGeometry = new THREE.BoxGeometry(4,0.2,4)
const floor1Material = new THREE.MeshStandardMaterial({color:'limegreen', roughness:0,metalness:0})
const floor2Material = new THREE.MeshStandardMaterial({color:'greenyellow', roughness:0,metalness:0})
const wallMaterial = new THREE.MeshStandardMaterial({color:'slategrey', roughness:0,metalness:0})
const obstacleMaterial = new THREE.MeshStandardMaterial({color:'orangered', roughness:0,metalness:0})
const goalMaterial = new THREE.MeshStandardMaterial({color:'gold', roughness:0,metalness:0})

export function BlockStart({position = [0, 0, 0]}){
    return(
        <group position={position}>
            <Float floatIntensity={0.25} rotationIntensity={0.25}>
                <Text 
                scale={0.4} 
                position={[0.75,0.65,0]}
                font='./bangers-v20-latin-regular.woff'
                maxWidth={0.25}
                lineHeight={0.75}
                textAlign='right'
                rotation-y={-0.25}
                
                >
                    <meshBasicMaterial toneMapped={false}/>
                    Marble Race
                </Text>
            </Float>
            <mesh scale={[4,0.2,4]} material={floor1Material} geometry={boxGeometry} receiveShadow position={ [0, -0.1, 0] } />
            
        </group>
    )
}
export function BlockEnd({position = [0, 0, 0]}){
    const hamburger = useGLTF('./bun.glb')
    hamburger.scene.children.forEach((child) => {
        child.castShadow = true
    })
    return(
        <group position={position}>
            <mesh scale={[4,0.2,4]} material={floor1Material} geometry={boxGeometry} receiveShadow position={ [0, 0, 0] } />
            <RigidBody type='fixed' colliders={'hull'} restitution={0.2} friction={0} position={[0,0.25,0]}>
                <primitive object={hamburger.scene} scale={0.2} />
            </RigidBody>
            <Float floatIntensity={0.25} rotationIntensity={0.25}>
                <Text 
                scale={0.8} 
                position={[0,2.25,0]}
                font='./bangers-v20-latin-regular.woff'
                >
                    <meshBasicMaterial toneMapped={false}/>
                    Finish
                </Text>
            </Float>
        </group>
    )
}

export function BlockSpinner({position = [0, 0, 0]}){
    const obstacle = useRef()
    const [speed, setSpeed] = useState(()=> (0.2+Math.random())*(Math.random() >0.5?1:-1))
    useFrame((state) => {
        const time = state.clock.getElapsedTime()
        const rotation = new THREE.Quaternion()
        rotation.setFromEuler(new THREE.Euler(0, time * speed, 0))
        if (obstacle.current)
            obstacle.current.setNextKinematicRotation(rotation)
    })
    return(
        <group position={position}>
            <mesh scale={[4,0.2,4]} material={floor2Material} geometry={boxGeometry} receiveShadow position={ [0, -0.1, 0] } />
            <RigidBody ref={obstacle} type='kinematicPosition' position={[0,0.3,0]} restitution={0.2} friction={0}>
                <mesh geometry={boxGeometry} material={obstacleMaterial} scale={[3.5,0.3,0.3]} castShadow receiveShadow />
            </RigidBody>

        </group>
    )
}

export function BlockLimbo({position = [0, 0, 0]}){
    const obstacle = useRef()
    const [speed, setSpeed] = useState(()=> (0.2+Math.random())*(Math.random() >0.5?1:-1))
    const [timeOffset, setTimeOffset] = useState(Math.random()*Math.PI*2)
    useFrame((state) => {
        const time = state.clock.getElapsedTime()
        if (obstacle.current)
            obstacle.current.setNextKinematicTranslation({x:position[0], y:position[1]+Math.sin(time+timeOffset) + 1.15, z:position[2]})
    })
    return(
        <group position={position}>
            <mesh scale={[4,0.2,4]} material={floor2Material} geometry={boxGeometry} receiveShadow position={ [0, -0.1, 0] } />
            <RigidBody ref={obstacle} type='kinematicPosition' position={[0,0.3,0]} restitution={0.2} friction={0}>
                <mesh geometry={boxGeometry} material={obstacleMaterial} scale={[3.5,0.3,0.3]} castShadow receiveShadow />
            </RigidBody>

        </group>
    )
}

export function BlockAxe({position = [0, 0, 0]}){
    const obstacle = useRef()
    const [speed, setSpeed] = useState(()=> (0.2+Math.random())*(Math.random() >0.5?1:-1))
    const [timeOffset, setTimeOffset] = useState(Math.random()*Math.PI*2)
    useFrame((state) => {
        const time = state.clock.getElapsedTime()
        let x = Math.sin(time+timeOffset) *1.25
        obstacle.current.setNextKinematicTranslation({x:position[0] + x, y:position[1] + 0.75, z:position[2]})
    })
    return(
        <group position={position}>
            <mesh scale={[4,0.2,4]} material={floor2Material} geometry={boxGeometry} receiveShadow position={ [0, -0.1, 0] } />
            <RigidBody ref={obstacle} type='kinematicPosition' position={[0,0.3,0]} restitution={0.2} friction={0}>
                <mesh geometry={boxGeometry} material={obstacleMaterial} scale={[1.5,1.5,0.3]} castShadow receiveShadow />
            </RigidBody>

        </group>
    )
}
function Bounds({length = 1}){
    return(
        <RigidBody type='fixed' restitution={0.2} friction={0}>
            <mesh scale={[0.3,1.5,4*length]} material={wallMaterial} geometry={boxGeometry} position={ [2.15, 0.75, length -3] } castShadow />
            <mesh scale={[0.3,1.5,4*length]} material={wallMaterial} geometry={boxGeometry} position={ [-2.15, 0.75, length -3] } receiveShadow />
            <mesh scale={[4,1.5,0.3]} material={wallMaterial} geometry={boxGeometry} position={ [0, 0.75, (-length)-3] }  receiveShadow />
            <CuboidCollider position={[0,-0.1,(length)-3]} args={[2,0.1,2*length]} restitution={0.2} friction={1} />
        </RigidBody>
    )
}

export default function Level({count = 5, types = [BlockSpinner, BlockLimbo, BlockAxe], seed=0})
{
    let blocks =  []
    useMemo(() => {
        blocks = []
        for(let i=0; i<count; i++){
            const type = types[Math.floor(Math.random()*types.length)]
            blocks.push(type)
        }
        blocks.push(BlockEnd)
        return blocks
    },[count, types, seed])
    return <>



        <BlockStart position={[0,0,16]} />
        {blocks.map((Block, index) => (
            <Block key={index} position={[0,0,16 - (index + 1) * 4]} />
        ))}
        <Bounds length={count+2}/>
    </>
}